import { CommonModule } from '@angular/common';
import { Component, computed, input, OnDestroy, OnInit } from '@angular/core';
import {
  GcAccordionComponent,
  GcIconComponent,
  GcTextComponent,
} from '@ip-only/front-end-library';
import { Subject } from 'rxjs';
import { SharedModule } from '../../../../../shared.module';
import { SelfInspectionCheckboxComponent } from '../../../../report-inputs/self-inspection-checkbox/self-inspection-checkbox.component';
import { SelfInspectionFileAndTextComponent } from '../../../../report-inputs/self-inspection-file-and-text/self-inspection-file-and-text.component';
import { SelfInspectionFilesComponent } from '../../../../report-inputs/self-inspection-files/self-inspection-files.component';
import { SelfInspectionListComponent } from '../../../../report-inputs/self-inspection-list/self-inspection-list.component';
import { SelfInspectionRadioButtonComponent } from '../../../../report-inputs/self-inspection-radio-button/self-inspection-radio-button.component';
import { SelfInspectionTextComponent } from '../../../../report-inputs/self-inspection-text/self-inspection-text.component';
import { RolloutProgressReportEntities } from '../../../../service/entities';
import { ReportGroupBaseComponent } from '../../../report-group-base/report-group-base.component';
@Component({
  selector: 'app-report-group',
  imports: [
    CommonModule,
    SharedModule,
    SelfInspectionTextComponent,
    SelfInspectionRadioButtonComponent,
    SelfInspectionListComponent,
    SelfInspectionCheckboxComponent,
    SelfInspectionFilesComponent,
    SelfInspectionFileAndTextComponent,
    GcAccordionComponent,
    GcIconComponent,
    GcTextComponent,
  ],
  templateUrl: './report-group.component.html',
  styleUrl: './report-group.component.scss',
})
export class ReportGroupComponent
  extends ReportGroupBaseComponent
  implements OnInit, OnDestroy
{
  reportGroupWithDefinitions =
    input.required<RolloutProgressReportEntities.v3.ReportGroupWithDefinitions>();

  private readonly cancelSub$ = new Subject<void>();

  definitionsWithAnswers: RolloutProgressReportEntities.v3.DefinitionWithAnswer[];
  reportAnswers: RolloutProgressReportEntities.v3.ReportAnswer[];

  definitionTypes = RolloutProgressReportEntities.v3.DefinitionType;
  language: string | null = this.languageService.getStoredLanguage();
  reportId: string = this.reportService.getStoredReportId();

  reportGroup = computed(
    () => this.reportGroupWithDefinitions().group.groupInfo.groupName,
  );
  isAllComplete = computed(
    () => this.reportGroupWithDefinitions().group.groupStatus.isCompleted,
  );

  accordionHeader = computed(() => {
    const group =
      this.reportGroupWithDefinitions().group.groupInfo.groupNameTranslations[
        this.language as keyof RolloutProgressReportEntities.v3.IdentifierObject
      ];
    const completedAmount =
      this.reportGroupWithDefinitions().group.groupStatus.selfInspectionsDone;
    const totalAmount =
      this.reportGroupWithDefinitions().group.groupStatus
        .totalAmountOfSelfInspections;

    return `${group} (${completedAmount}/${totalAmount})`;
  });

  ngOnInit(): void {
    this.combineDefinitionWithReportAnswer();
    this.convertAnswers();
  }

  ngOnDestroy() {
    this.cancelSub$.next();
  }

  combineDefinitionWithReportAnswer = (): void => {
    this.definitionsWithAnswers =
      this.reportGroupWithDefinitions().definitions.map((definition) => ({
        ...definition,
        answer: this.reportGroupWithDefinitions().selfInspections.find(
          ({ selfInspectionDefinitionId }) =>
            selfInspectionDefinitionId === definition.id,
        ),
      }));
  };

  convertAnswers = (): void => {
    this.reportAnswers = this.definitionsWithAnswers.map((defWithAnswer) => ({
      data: this.helperService.convertAnswer(
        defWithAnswer.type,
        defWithAnswer,
        this
          .language as keyof RolloutProgressReportEntities.v3.IdentifierObject,
      ),
      wrapperData: this.helperService.createWrapperData(
        defWithAnswer,
        this
          .language as keyof RolloutProgressReportEntities.v3.IdentifierObject,
      ),
    }));
  };
}
